import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, filter, map, switchMap, withLatestFrom} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {Client} from '../models/client';
import {SendBackResult} from '../models/send-back-result';
import {ClientsService} from '../services/clients.service';

import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';
import {cmsActionTypes, LoadCMSAction, LoadCMSFailAction, LoadCMSSuccessAction} from '../actions/cms';
import {CmsService} from '../services/cms.service';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as _ from 'lodash';
import {ServerForm} from '../models/servers';
import {LoadServerURLAction} from '../actions/servers-url';

@Injectable()
export class CmsEffectEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
              ofType(cmsActionTypes.LOAD),
              map((action: LoadCMSAction) => action.payload),
              debug('Load CMS action received.'),
              withLatestFrom(this.store.pipe(
                select(fromRoot.selectors.getCurrentClient),
                filter(client => !_.isEmpty(client))
              )),
             switchMap( ([action, client]) => this.cmsService.getCMS(client.uuid , action.productID , action.serviceType).pipe(
                              map((result: SendBackResult<ArrayResponse<ServerForm>>) => new LoadCMSSuccessAction(result.data.array)),
                              catchError(res => this.catchResponseError(res)),
                              )))});


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(cmsActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving CMS list.'),
    map((action: LoadCMSFailAction) =>
      error(this.translation.translate('CMS_LOAD_ERROR') + '  ' + action.payload,
      this.translation.translate('TOAST_ERROR_TITLE')))) });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private store: Store<fromRoot.AppState>,
              private cmsService: CmsService, router: Router) { super(router); }

  protected handleUnhandledError = (response) => new LoadCMSFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadCMSFailAction(response['error'].message);
  }
}
